module.exports = "/fonts/efiling-logotype-l-cd01abd1bd7eb573ead8a2675e3ebdbc.svg";